import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetRisks = (params, signal) => axios.get(apiPaths.risksBase, { params, signal });

const onExportRisks = (risksIds) =>
  axios.post(`${apiPaths.risksBase}/create-export-file`, risksIds, { responseType: 'arraybuffer' });

export { onGetRisks, onExportRisks };
